var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('el-container',[_c('el-main',[_c('el-menu',{staticClass:"retro__nav",attrs:{"mode":"horizontal"}},[_c('img',{staticClass:"retro__nav-logo",attrs:{"src":"img/umov-me-transforming-your-business.png","alt":""}}),_c('span',{staticClass:"retro__nav-title"},[_vm._v("uRetroMaker")])]),_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }